import { NgModule, ModuleWithProviders, Type } from '@angular/core';
import { CommonModule } from '@angular/common';

import { DynamicFormDesignerModule } from 'zr-dynamic-form/dynamic-form-designer';
import { DynamicFormCommonModule } from 'zr-dynamic-form/dynamic-form-common';

import { LayoutHostRuntimeDirective } from './utils/layout-host-runtime.directive';

import { DynamicFormRuntimeComponent } from './dynamic-form-runtime.component';
import { DynamicFormRuntimeConfig } from './utils/dynamic-form-runtime-config';
import { FormDataService } from './services/form-data.service';

@NgModule({
  imports: [CommonModule, DynamicFormDesignerModule, DynamicFormCommonModule],
  declarations: [DynamicFormRuntimeComponent, LayoutHostRuntimeDirective],
  exports: [DynamicFormRuntimeComponent],
  entryComponents: [DynamicFormRuntimeComponent],
  providers: [FormDataService]
})
export class DynamicFormRuntimeModule {
  static forRoot(config: Type<DynamicFormRuntimeConfig>): ModuleWithProviders {
    return {
      ngModule: DynamicFormRuntimeModule,
      providers: [{ provide: DynamicFormRuntimeConfig, useClass: config }]
    };
  }
}
